import React, { useState, useEffect } from 'react'
import StatsAndStandingsHomeNavigation from '../../shared/components/Navigation/StatsAndStandingsHomeNavigation'
import SelectLeague from '../../shared/components/UIElements/SelectLeague'
import { useHttpClient } from '../../shared/hooks/http-hook'
import Footer from '../../shared/components/UIElements/Footer'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import './PreviousLeagues.css'
import Banner from '../../shared/components/Navigation/Banner'
import { Link, NavLink } from 'react-router-dom'

const PreviousLeagues = () => {
	const { sendRequest, clearError } = useHttpClient()
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [leagueId, setLeagueId] = useState('')
	const [loadedPreviousLeagues, setLoadedPreviousLeagues] = useState()

	const [isMobile, setIsMobile] = useState(window.innerWidth <= 440)

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 440)
		}

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	//Make a call to the backend to return all previous (archived) leagues.  getPreviousLeagues
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/league/previousLeagues',
				)
				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedPreviousLeagues(responseData.previousLeagues)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [])
	//
	//console.log('loadedPreviousLeagues: ' + JSON.stringify(loadedPreviousLeagues))
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	//
	const handleClick = (e) => {
		//e.preventDefault()
		//console.log('e: ' + e)
	}
	//
	//
	//
	return (
		<div style={{ overflowX: 'hidden' }}>
			<ErrorModal error={error} onClear={errorHandler} />
			<SelectLeague />
			{isLoading && (
				<div className='center'>
					<LoadingSpinner />
				</div>
			)}
			{!isLoading && !loadedPreviousLeagues && (
				<div className='PreviousTournaments'>
					<h1>No Previous Leagues Found!</h1>
				</div>
			)}
			{!isLoading && loadedPreviousLeagues && (
				<div className='PreviousTournaments'>
					{!isMobile && (
						<div style={{ marginBottom: '1rem' }}>
							<Banner />
						</div>
					)}
					<h1>Previous Tournaments</h1>
					<table id='listOfPreviousTournaments'>
						<thead>
							<tr>
								<th>Year</th>
								<th>Tournament</th>
							</tr>
						</thead>
						<tbody>
							{loadedPreviousLeagues.map((league, key) => {
								return (
									<tr key={key}>
										<td>{league.year}</td>
										<td>
											<Link
												to={`/league/${league._id}`}
												style={{
													color: 'black',
													fontWeight: 600,
													textDecoration: 'none',
												}}
											>
												{league.leagueName}{' '}
												{league.divisionName &&
													' - ' + league.divisionName + ' Division'}
											</Link>
										</td>
									</tr>
								)
							})}
						</tbody>
					</table>
				</div>
			)}
			<StatsAndStandingsHomeNavigation leagueId={leagueId} />
			<Footer />
		</div>
	)
}

export default PreviousLeagues
